<template>
    <v-layout style="width: 100%; height: 100%; position: relative" class="live-support-layout">
        <CoolLightBox
                :items="lightBoxData"
                :index="lightBoxIndex"
                @close="hideLightBox()">
        </CoolLightBox>
        <div class="bot-view-wrap">
            <BotView></BotView>
        </div>
        <div :style="chatViewStyle" class="chat-view-wrap">
            <ChatView ref="v_chat_view"></ChatView>
        </div>
        <div v-show="showSideBox" class="sidebar-wrap">
            <Notes v-if="showNotes"></Notes>
            <StaffChat ref="v_staff_chat" v-show="showStaffChat"></StaffChat>
            <AssignView v-if="showAssignSupporter"></AssignView>
            <SessionInfo v-if="showSessionInfo"></SessionInfo>
            <MarkAsDone v-if="showMarkAsDone"></MarkAsDone>
            <TicketManagement v-if="showTicket"></TicketManagement>
        </div>
        <div class="fixed" v-if="!chatView.senderId" :style="chatNotifyStyle">
            <ToggleStaffChat></ToggleStaffChat>
        </div>
        <div>
            <default-dialog></default-dialog>
        </div>
    </v-layout>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import ChatView from "../components/ChatView";
import BotView from "../components/botview/BotView";
import BotService from "src/services/bot.service";
import {SocketMixin} from "@/mixins/SocketMixin";
import Notes from "../components/side-box/Notes";
import MarkAsDone from "@/components/side-box/MarkAsDone";
import SessionInfo from "@/components/side-box/SessionInfo";
import TicketManagement from "@/components/side-box/TicketManagement";
import StaffChat from "@/components/side-box/StaffChat";
import AssignView from "../components/side-box/AssignView";
import ToggleStaffChat from "@/components/custom/ToggleStaffChat";

export default {
    name: 'Main',
    components: {
        Notes,
        MarkAsDone,
        SessionInfo,
        AssignView,
        StaffChat,
        ToggleStaffChat,
        ChatView,
        BotView,
        TicketManagement,
        DefaultDialog: ()=> import(
            "../components/dialog/Index"
            )
    },
    mixins: [SocketMixin],
    computed: {
        ...mapState([
            'notifyStaffChat',
            'isSmallScreen',
            'chatView',
            'lightBoxData',
            'lightBoxIndex'
        ]),
        ...mapState('sideBox', [
            'showSideBox',
            'showTicket',
            'showStaffChat',
            'showAssignSupporter',
            'showMarkAsDone',
            'showSessionInfo',
            'showNotes'
        ]),
        chatNotifyStyle () {
            return {
                right: this.showSideBox ? '382px' : '20px'
            }
        },
        chatViewStyle () {
            let botViewSize = '400px';
            let sideBoxSize = !this.isSmallScreen && this.showSideBox ? '357px' : '0px';
            let maxWidth = `calc(100% - ${botViewSize} - ${sideBoxSize})`;
            return {
                flex: '0 0 ' + maxWidth,
                maxWidth: maxWidth
            }
        }
    },
    mounted () {
        this.$store.dispatch(this.$ActionTypes.GET_BOT_STAFF);
        let botCode = this.$route.params.bot_code;
        this.startUp(botCode);
    },
    watch: {
        '$route.params.bot_code': {
            handler() {
                let botCode = this.$route.params.bot_code;
                this.startUp(botCode)
            }
        },
        '$route.params.senderId': {
          handler() {
            let botCode = this.$route.params.bot_code;
            let senderId = this.$route.params.senderId;
            if (senderId) {
              this.getCountOpening({botCode, senderId})
            }
          }
        },
    },
    methods: {
        ...mapActions('ticket', ['getCountOpening']),
        ...mapActions('config', ['getBotConfig', 'getUserConfig']),
        ...mapActions('autoAssign', ['getStatus']),
        hideLightBox() {
            this.$store.dispatch(this.$ActionTypes.SET_LIGHT_BOX_DATA_THEN_SHOW, {})
        },
        toggleStaffChat () {
            this.$store.commit(this.$ActionTypes.TOGGLE_STAFF_CHAT)
        },
        //Initial data loading page
        startUp(botCode) {
            //Auto assign status
            this.getStatus();
            //User config
            this.getUserConfig();
            if (botCode) {
                this.getBotConfig(botCode);
                BotService.getAgentConfigs(botCode);
            }
        }
    }
};
</script>
<style scoped lang="scss" src="../components/style/main.scss"></style>
